import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'

// PLOP_APPEND_PATTERN_ANCHOR

export function getUsersService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.users
  })
}
